<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{ newForm ? "Nova" : "Editar" }} Competência</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    :items="power_plants"
                    item-text="name"
                    prepend-icon="flash_on"
                    label="Planta*"
                    v-model="power_plant"
                    return-object
                    :rules="[
                      (v) => !!v || 'Selecione a Planta que deseja ver fatura',
                    ]"
                    :disabled="!newForm"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3 md4>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-on="on"
                        v-model="power_plant_power_monthly"
                        label="Geração Esperada"
                        readonly
                      />
                    </template>
                    <span
                      >Este é um valor estimado de geração para essa usina. A
                      energia gerada varia durante o ano mas não deve possuir um
                      valor que se distancie muito desse.</span
                    >
                  </v-tooltip>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="competence"
                    :rules="competenceRules"
                    label="Competência*"
                    prepend-icon="event"
                    class="purple-input"
                    required
                    :value="current_date"
                    mask="##/####"
                    :disabled="!newForm || !power_plant"
                    @change="getLastCompetence(competence)"
                  />
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    v-model="power_plant_amount"
                    label="Créditos Gerados"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="power_plant_consumption_kW"
                    label="Consumo da Planta"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="power_plant_custo_disp_kW"
                    label="Custo de Disponibilidade"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    v-model.number="last_balance"
                    label="Saldo Anterior"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    v-model.number="current_balance"
                    label="Saldo Atual"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-menu
                    v-model="read_at_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="read_at"
                        label="Data de leitura"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      dark
                      v-model="read_at"
                      @input="read_at_menu = false"
                      :min="minCalendarDate"
                      :max="today"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-menu
                    v-model="issued_at_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="issued_at"
                        label="Data de emissão"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      dark
                      v-model="issued_at"
                      @input="issued_at_menu = false"
                      :min="minCalendarDate"
                      :max="today"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-menu
                    v-model="next_read_at_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="next_read_at"
                        label="Data de próxima leitura"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      dark
                      v-model="next_read_at"
                      @input="next_read_at_menu = false"
                      :min="today + 1"
                      :max="maxCalendarDate"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="start_at"
                        label="Data de inicio do faturamento"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      dark
                      v-model="start_at"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 md3 class="pb-0">
                  <v-text-field
                    v-model="estimated_kwh_value"
                    type="number"
                    label="Tarifa Energia Elétrica"
                    :readonly="!canEditFare"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 class="pb-0">
                  <v-text-field
                    v-model="estimated_kwh_comp_value"
                    type="number"
                    label="Tarifa Energia Compensada s/ ICMS"
                    :readonly="!canEditFare"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 class="pb-0">
                  <v-text-field
                    v-model="estimated_kwh_amount_value"
                    type="number"
                    label="Tarifa Energia Injetada HFP"
                    :readonly="!canEditFare"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 class="pb-0">
                  <v-btn @click="openConfigFareDialog" color="primary" block>
                    Atualizar tarifas
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="pt-0" v-if="dynamic_fares_text">
                  <p class="caption">{{ dynamic_fares_text }}</p>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <div class="mx-auto d-flex justify-center">
                    <v-checkbox
                      label="Conta Retida?"
                      v-model="retained_account"
                      block
                      class="align"
                    ></v-checkbox>
                  </div>
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    v-model="total_payable"
                    label="Total a pagar"
                    type="number"
                    prefix="R$"
                    :rules="
                      retained_account
                        ? []
                        : [(v) => !!v || 'Por favor, esse dado é obrigatório.']
                    "
                    :readonly="retained_account"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    v-model.number="adjustment_or_fine"
                    label="Ajuste/Multa"
                    type="number"
                    required
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 class="pb-0" v-if="newForm">
                  <div>
                    <v-btn
                      v-if="upload_file[0]?.name"
                      @click.prevent="removeEnergyBill()"
                      color="primary"
                      :loading="loading_parse_bill"
                      block
                    >
                      {{ upload_file[0]?.name }}
                      <v-icon class="ml-2" size="16">mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      @click.prevent="pickEnergyBill"
                      color="primary"
                      block
                    >
                      <v-icon class="mr-2" size="16">upload</v-icon>
                      ANEXAR CONTA DE ENERGIA
                    </v-btn>
                  </div>
                  <input
                    type="file"
                    ref="upload_file"
                    style="display: none"
                    @change="pickedEnergyBill($event)"
                    accept="image/*, application/pdf"
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 v-else>
                  <v-btn @click="invoiceCompetenceModal" color="primary" block>
                    DOCUMENTOS
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm4 md12>
                  <v-card
                    color="blue-grey darken-2"
                    class="text-xs-center white--text pa-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small color="white" v-on="on"> info </v-icon>
                      </template>
                      <span
                        >Essa é uma comparação da energia gerada nessa
                        competência com o valor de geração esperado que essa
                        usina possui. Uma diferença muito grande entre os
                        valores pode significar algum problema com a
                        geração.</span
                      >
                    </v-tooltip>
                    Foram geradas
                    {{
                      power_plant_power_monthly && power_plant_amount
                        ? (
                            (this.power_plant_amount /
                              this.power_plant_power_monthly) *
                            100
                          ).toFixed(2)
                        : "-"
                    }}% da energia esperada para essa planta
                  </v-card>
                </v-flex>
                <small><br />*Campos obrigatórios</small>
                <v-flex xs12>
                  <v-divider />
                  <v-card color="#fff">
                    <v-card-text>
                      <h5>Split da Competência</h5>
                    </v-card-text>
                    <v-divider />
                    <v-data-table
                      :headers="headers_split"
                      :items="split"
                      hide-actions
                      v-if="this.split && this.split.length > 0"
                    >
                      <template v-slot:items="props">
                        <td>
                          {{ props.item.partner }}
                        </td>
                        <td class="text-xs-right">
                          {{ props.item.recipient_id }}
                        </td>
                        <td class="text-xs-right">
                          {{ props.item.percentage }}%
                        </td>
                        <td class="text-xs-right">
                          <v-icon color="red" @click="deleteSplit(props.index)"
                            >delete</v-icon
                          >
                        </td>
                      </template>
                      <template v-slot:footer>
                        <td><strong>Total</strong></td>
                        <td></td>
                        <td class="text-xs-right">
                          <strong>{{ totalPercentual }}%</strong>
                        </td>
                        <td></td>
                      </template>
                    </v-data-table>
                    <v-card-actions>
                      <div class="text-xs-right">
                        <v-btn
                          outline
                          darked
                          color="primary"
                          @click="addSplit = true"
                          v-if="totalPercentual < 100"
                          >Incluir</v-btn
                        >
                      </div>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              flat
              @click.prevent="close()"
              :disabled="loading"
              >Cancelar</v-btn
            >
            <v-btn
              color="blue darken-1"
              flat
              @click="validate()"
              :loading="loading"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-dialog>
    <v-dialog v-model="addSplit" persistent max-width="600px">
      <v-form ref="addSplitform" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline">Split para a Competência</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    :items="partners"
                    item-text="name"
                    item-value="id"
                    label="Parceiro"
                    return-object
                    name="partner"
                    v-model.lazy="partner"
                    :rules="[(v) => !!v || 'Por favor, selecione o Parceiro!']"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :items="bankAccounts"
                    :item-text="bankText"
                    return-object
                    label="Conta Bancaria"
                    v-model.lazy="bankAccount"
                    :rules="[
                      (v) => !!v || 'Por favor, selecione a conta Bancaria!',
                    ]"
                    :disabled="bankAccountsLoading"
                    required
                  ></v-autocomplete>
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    size="20"
                    v-if="bankAccountsLoading"
                    class="text-xs-center"
                  ></v-progress-circular>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    label="Porcentagem*"
                    required
                    v-model.number="split_form.percentage"
                    :rules="[
                      (v) => !!v || 'A porcentagem deve ser maior que 0 (zero)',
                      (v) =>
                        v > 0 || 'A porcentagem deve ser maior que 0 (zero)!',
                      (v) =>
                        v + totalPercentual <= 100 ||
                        'A porcentagem total deve ser menor que 100%, faltam ' +
                          (100 - totalPercentual) +
                          '%!',
                    ]"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-checkbox
                    v-model="split_form.liable"
                    label="Assume Riscos de chargeback"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-checkbox
                    v-model="split_form.charge_processing_fee"
                    label="Assume Taxas de Transação"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="addSplit = false"
              >Fechar</v-btn
            >
            <v-btn color="blue darken-1" flat @click="saveSplit(split_form)"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="showFaresDialog" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="py-2">
          <div class="headline font-weight-bold mx-auto">Cadastrar tarifa</div>
        </v-card-title>
        <v-card-text class="pt-2 pb-3">
          <div xs12 md12 class="dialog-container mx-4">
            <v-form
              ref="fares_form"
              v-model="valid"
              lazy-validation
              v-if="showFaresDialog"
            >
              <v-flex xs12>
                <v-text-field
                  v-model="config_fares.competence"
                  :rules="competenceRules"
                  label="Competência"
                  prepend-icon="event"
                  class="purple-input"
                  required
                  mask="##/####"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="config_fares.estimated_kwh_value"
                  type="number"
                  label="Tarifa Energia Elétrica"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v || 'Por favor, digite a Tarifa Energia Elétrica!',
                  ]"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="config_fares.estimated_kwh_comp_value"
                  type="number"
                  label="Tarifa Energia Compensada s/ ICMS"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, digite a Tarifa Energia Compensada s/ ICMS!',
                  ]"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="config_fares.estimated_kwh_amount_value"
                  type="number"
                  label="Tarifa Energia Injetada HFP (GD I)"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, digite a Tarifa Energia Injetada HFP (GD I)!',
                  ]"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="config_fares.estimated_kwh_amount_value_gd2"
                  type="number"
                  label="Tarifa Energia Injetada HFP (GD II)"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, digite a Tarifa Energia Injetada HFP (GD II)!',
                  ]"
                  required
                />
              </v-flex>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="showFaresDialog = false"
              >Fechar</v-btn
            >
            <v-btn color="pink darken-1" text @click="createConfigFare"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <invoiceDocumentModal ref="documentModal" @parseBill="detectFiles" />
  </v-layout>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import {
  createTotalBilling,
  getTotalBilling,
  updateUtilityFares,
} from "../../services/billing";
import { updateInvoiceTotal } from "../../services/invoices";
import { uploadEnergyBill } from "../../services/powerplants";
import { getBankAccounts } from "../../services/split";
import { uploadInvoice } from "../../services/uploadInvoice";
import { EventBus } from "../../utils/event-bus";
import invoiceDocumentModal from "./invoiceDocumentModal.vue";

export default {
  props: ["power_plants"],

  components: { invoiceDocumentModal },

  data: () => ({
    dialog: false,
    competence: "",
    competenceRules: [
      (v) => !!v || "Por favor, preencher a competência da fatura.",
      (v) =>
        v?.substring(2, 6) >= 2019 ||
        "Por favor, o ano deve ser valido. " + v?.substring(2, 6),
      (v) =>
        v?.substring(0, 2) <= 12 ||
        "Por favor, o mes deve ser valido. " + v?.substring(0, 2),
    ],
    power_plant: "",
    power_plant_name: "",
    power_plant_id: "",
    power_plant_amount: 0,
    power_plant_power_monthly: 0,
    power_plant_consumption_kW: 0,
    power_plant_custo_disp_kW: 0,
    number_of_customers: 0,
    last_balance: 0,
    dias_leitura: 0,
    current_balance: 0,
    valor_conta: 0,
    current_date: new Date(),
    valid: false,
    loading: false,
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: "",
    snackbar: false,
    totals: {},
    newForm: true,
    cobraCustoDisp: true,
    retira_imposto: true,
    menu2: false,
    start_at: new Date().toISOString().split("T")[0],
    read_at_menu: false,
    read_at: null,
    issued_at_menu: false,
    issued_at: null,
    next_read_at_menu: false,
    next_read_at: null,
    today: moment().format("YYYY-MM-DD"),
    minCalendarDate: null,
    maxCalendarDate: null,
    auto_invoice_submission: true,
    auto_transaction: true,
    retained_account: false,
    total_payable: null,
    adjustment_or_fine: 0,
    split: [],
    headers_split: [
      {
        text: "Parceiro",
        align: "left",
        value: "partner",
      },
      {
        text: "Código",
        align: "right",
        value: "recipient_id",
      },
      {
        text: "Percentual",
        align: "right",
        value: "percentage",
      },
      { text: "" },
    ],
    upload_file_link: null,
    upload_file: {
      name: "",
      data: null,
    },
    loading_parse_bill: false,
    max25chars: (v) => v.length <= 25 || "Input too long!",
    addSplit: false,
    split_form: {
      charge_processing_fee: true,
      liable: true,
      partner: true,
      percentage: 0,
      recipient_id: null,
    },
    bankAccount: null,
    bankAccounts: [],
    bankAccountsLoading: false,
    partner: null,
    estimated_kwh_value: null,
    estimated_kwh_comp_value: null,
    estimated_kwh_amount_value: null,
    showFaresDialog: false,
    config_fares: {
      competence: null,
      estimated_kwh_value: null,
      estimated_kwh_comp_value: null,
      estimated_kwh_amount_value: null,
      estimated_kwh_amount_value_gd2: null,
    },
    dynamic_fares_text: null,
    canEditFare: true,
    uploadedDoc: false,
  }),

  computed: {
    ...mapState("configuration", ["partners"]),
    ...mapState(["config"]),
    ...mapState(["user"]),

    totalPercentual() {
      if (!this.split || this.split.length <= 0) return 0;
      return this.split.reduce((accumulator, val) => {
        return accumulator + val.percentage;
      }, 0);
    },
  },

  mounted() {
    if (!this.partners || this.partners.length <= 0) this.getPartners();

    this.updateMinDate();
    this.updateMaxDate();
  },

  created() {
    EventBus.$on("showForm", (show) => {
      this.dialog = show;
    });
  },

  watch: {
    power_plant() {
      if (this.power_plant) {
        this.getLastCompetence(this.competence);
        this.split = this.power_plant.split;
      }
    },

    async partner() {
      this.bankAccounts = [];
      this.bankAccountsLoading = true;
      if (this.partner.bankAccounts)
        this.bankAccounts = await getBankAccounts(this.partner.bankAccounts);
      if (this.bankAccounts.length === 1)
        this.bankAccount = this.bankAccounts[0];
      this.bankAccountsLoading = false;
    },
  },

  methods: {
    ...mapActions("configuration", [
      "getPartners",
      "getEnergyBill",
      "getDocumentsCompetence",
    ]),
    ...mapActions("cs", ["getPowerPlantByID"]),
    ...mapActions(["setInitialsConfig"]),

    close() {
      this.dialog = false;
      this.split = [];
      this.newForm = true;
      this.upload_file = {
        name: "",
        data: null,
      };
      this.upload_file_link = null;
      this.$refs.form.reset();
    },

    lastCompetence(competence) {
      let _month = Number(competence.substring(0, 2));
      let _year = Number(competence.substring(2, 6));
      if (Number(_month) === 1) {
        _year = _year - 1;
        _month = 12;
      } else {
        _month = _month - 1;
      }
      return (
        _year.toString() +
        "-" +
        (_month < 10 ? "0" + _month.toString() : _month.toString())
      );
    },

    async getLastCompetence(competence) {
      this.dynamic_fares_text = null;
      this.canEditFare = true;
      const mes = this.competence.substring(0, 2);
      const ano = this.competence.substring(2, 6);
      const power_plant_id = this.power_plant.power_plant_id;
      const last_competence = this.lastCompetence(competence);
      const newCompetence = ano + "-" + mes;
      await getTotalBilling(this.power_plant.id, last_competence)
        .then(async (doc) => {
          if (doc.exists) {
            const lastTotalBillling = {
              ...doc.data(),
              id: doc.id,
            };
            this.last_balance = lastTotalBillling.current_balance;
          }
          if (!this.uploadedDoc) {
            await this.getCompetenceData(competence);
          }
          this.getEnergyFile(`${power_plant_id}-${newCompetence}`);
        })
        .catch((err) => {
          this.snack("Erro ao buscar competência" + err, "red", "top");
        });

      if (this.newForm) {
        const competence = this.competence?.replace(/(\d{2})(\d{4})/, "$2-$1");
        const formatedCompetence = this.competence?.replace(
          /(\d{2})(\d{4})/,
          "$1/$2",
        );
        const fares = this.config.fares?.find(
          (item) => item.competence == competence,
        );
        if (fares) {
          let modality;
          this.estimated_kwh_value = fares.estimated_kwh_value;
          this.estimated_kwh_comp_value = fares.estimated_kwh_comp_value;
          if (this.power_plant?.fare_modality === "GDII") {
            modality = "GD II";
            this.estimated_kwh_amount_value =
              fares.estimated_kwh_amount_value_gd2;
          } else {
            modality = "GD I";
            this.estimated_kwh_amount_value = fares.estimated_kwh_amount_value;
          }
          this.snack(
            `Tarifas ${modality} da competência ${formatedCompetence} preenchidas.`,
            "green",
            "top",
          );
          this.dynamic_fares_text = `Tarifas ${modality} da competência ${formatedCompetence} cadastradas por ${
            fares.agent_email
          } em ${this.formatDateTime(fares.created_at)}.`;
          if (this.power_plant?.utility_company == "cemig") {
            this.canEditFare = false;
          }
        }
      }
    },

    openConfigFareDialog() {
      this.config_fares.estimated_kwh_amount_value =
        this.config?.fares[
          this.config.fares.length - 1
        ]?.estimated_kwh_amount_value;
      this.config_fares.estimated_kwh_amount_value_gd2 =
        this.config?.fares[
          this.config.fares.length - 1
        ]?.estimated_kwh_amount_value_gd2;
      this.showFaresDialog = true;
    },

    async createConfigFare() {
      if (this.$refs.fares_form.validate()) {
        const competence = this.config_fares?.competence?.replace(
          /(\d{2})(\d{4})/,
          "$2-$1",
        );
        const formatedCompetence = this.config_fares?.competence?.replace(
          /(\d{2})(\d{4})/,
          "$1/$2",
        );
        const fareFound = this.config.fares.some(
          (item) => item.competence == competence,
        );
        if (fareFound) {
          this.snack(
            `Tarifas da competência ${formatedCompetence} já foram cadastradas.`,
            "red",
            "top",
          );
          return;
        }

        const newFares = {
          created_at: new Date(),
          agent_email: this.user?.email,
          competence: this.config_fares?.competence?.replace(
            /(\d{2})(\d{4})/,
            "$2-$1",
          ),
          estimated_kwh_value: parseFloat(
            this.config_fares.estimated_kwh_value,
          ),
          estimated_kwh_comp_value: parseFloat(
            this.config_fares.estimated_kwh_comp_value,
          ),
          estimated_kwh_amount_value: parseFloat(
            this.config_fares.estimated_kwh_amount_value,
          ),
          estimated_kwh_amount_value_gd2: parseFloat(
            this.config_fares.estimated_kwh_amount_value_gd2,
          ),
        };

        const data = {
          fares: [...this.config.fares, newFares],
          updated_at: new Date(),
          last_agent_email: this.user?.email,
        };

        await updateUtilityFares(data)
          .then(() => {
            this.snack(
              `Tarifas da competência ${formatedCompetence} cadastradas com sucesso.`,
              "green",
              "top",
            );
            this.showFaresDialog = false;
            this.config_fares = {
              competence: null,
              estimated_kwh_value: null,
              estimated_kwh_comp_value: null,
              estimated_kwh_amount_value: null,
              estimated_kwh_amount_value_gd2: null,
            };
            this.setInitialsConfig();
          })
          .catch((error) => {
            console.error("error", error);
            this.snack(`Erro ao atualizar tarifas.`, "red", "top");
          });
      } else {
        this.snack("Preencha todos os campos obrigatórios.", "red", "top");
      }
    },

    formatDateTime(date) {
      if (!date || date === "") return "";
      if (typeof date === "string") return moment(date).format("DD/MM/YYYY");
      else return moment(date.toDate()).format("DD/MM/YYYY");
    },

    async getCompetenceData(competence) {
      const month = competence.substring(0, 2);
      const year = competence.substring(2, 6);
      const atualCompetence = year + "-" + month;
      await getTotalBilling(this.power_plant.id, atualCompetence)
        .then((doc) => {
          if (!doc.exists) return;

          const totalBillling = {
            ...doc.data(),
            id: doc.id,
          };
          this.newForm = false;
          this.power_plant_power_monthly =
            totalBillling.power_plant_power_monthly ??
            this.power_plant_power_monthly;
          this.power_plant_amount = totalBillling.power_plant_amount;
          this.power_plant_consumption_kW =
            totalBillling.power_plant_consumption_kW;
          this.power_plant_custo_disp_kW =
            totalBillling.power_plant_custo_disp_kW;
          this.current_balance = totalBillling.current_balance;
          this.read_at = totalBillling.read_at ?? this.read_at;
          this.start_at = totalBillling.start_at ?? this.start_at;
          this.issued_at = totalBillling.issued_at ?? this.issued_at;
          this.next_read_at = totalBillling.next_read_at ?? this.next_read_at;
          this.cobraCustoDisp = totalBillling.cobraCustoDisp;
          this.retira_imposto = totalBillling.retira_imposto;
          this.auto_invoice_submission = totalBillling.auto_invoice_submission;
          this.auto_transaction =
            totalBillling.auto_transaction ?? this.auto_transaction;
          this.retained_account =
            totalBillling.retained_account ?? this.retained_account;
          this.total_payable =
            totalBillling.total_payable ?? this.total_payable;
          this.adjustment_or_fine =
            totalBillling.adjustment_or_fine ?? this.adjustment_or_fine;
          this.estimated_kwh_value =
            parseFloat(totalBillling.estimated_kwh_value) ??
            this.estimated_kwh_value;
          this.estimated_kwh_comp_value =
            parseFloat(totalBillling.estimated_kwh_comp_value) ??
            this.estimated_kwh_comp_value;
          this.estimated_kwh_amount_value =
            parseFloat(totalBillling.estimated_kwh_amount_value) ??
            this.estimated_kwh_amount_value;
          this.estimated_kwh_amount_value_gd2 =
            parseFloat(totalBillling.estimated_kwh_amount_value_gd2) ??
            this.estimated_kwh_amount_value_gd2;
          this.split = totalBillling.split;
        })
        .catch((err) => {
          this.snack("Erro ao buscar competência" + err, "red", "top");
        });
    },

    updateMinDate() {
      const today = moment();
      this.minCalendarDate = today.subtract(45, "days").format("YYYY-MM-DD");
    },

    updateMaxDate() {
      const today = moment();
      this.maxCalendarDate = today.add(46, "days").format("YYYY-MM-DD");
    },

    invoiceCompetenceModal() {
      const mes = this.competence.substring(0, 2);
      const ano = this.competence.substring(2, 6);
      const newCompetence = ano + "-" + mes;
      this.$refs.documentModal.invoiceCompetenceModal(
        this.power_plant.power_plant_id,
        newCompetence,
      );
    },

    async uploadInv(formData) {
      return await uploadInvoice(formData);
    },

    async detectFiles(fileList) {
      Array.from(Array(fileList.length).keys()).map((x) => {
        this.loading_parse_bill = true;
        let formData = new FormData();
        formData.append("invoice", fileList[x]);

        this.uploadInv(formData)
          .then(async (res) => {
            const bill = res?.data;
            this.uploadedDoc = true;
            const planta = await this.getPowerPlantByID(bill.numero_instalacao);
            this.power_plant = planta || this.power_plant;
            if (this.power_plant?.type == "mini") {
              this.competence = moment(bill.competencia)
                .add(1, "M")
                .format("MMYYYY");
            } else {
              this.competence = moment(bill.competencia).format("MMYYYY");
            }
            await this.getCompetenceData(this.competence);
            this.power_plant = planta || this.power_plant;
            this.power_plant_amount = this.setCreditosGerados(bill);
            this.power_plant_consumption_kW = this.setConsumo(bill);
            this.power_plant_custo_disp_kW = this.setCustoDisp(bill.classe);
            this.current_balance = bill.saldo;
            this.read_at = bill.leitura_atual;
            this.issued_at = bill.emissao;
            this.next_read_at = bill.leitura_proxima;
            this.retained_account = bill.boleto ? false : true;
            this.total_payable = this.centsToReal(bill.valor_a_pagar);
            this.adjustment_or_fine = this.setAjusteMulta(bill);
            this.updatePowerPlantPowerMonthly();
            this.loading_parse_bill = false;
            this.snack(
              "Conta de energia carregada com sucesso!",
              "green",
              "top",
            );
          })
          .catch((error) => {
            this.loading_parse_bill = false;
            this.uploadedDoc = false;
            this.snack(
              "Erro ao fazer o parse da conta de energia.",
              "red",
              "top",
            );
            console.error("Erro ao fazer parse da conta: ", error);
          });
      });
    },

    setCustoDisp(classe) {
      const lowerCaseClasse = classe
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      if (lowerCaseClasse.includes("monofasico")) {
        return 30;
      } else if (lowerCaseClasse.includes("bifasico")) {
        return 50;
      } else if (lowerCaseClasse.includes("trifasico")) {
        return 100;
      } else {
        return 0;
      }
    },

    setAjusteMulta(bill) {
      let ajuste_multa = 0;
      const multa = bill.valores_faturados.find((item) => {
        return item.descricao?.includes("Multa");
      });
      if (multa) {
        ajuste_multa += this.centsToReal(multa.valor) ?? 0;
      }

      const juros = bill.valores_faturados.find((item) => {
        return item.descricao?.includes("Juros");
      });
      if (juros) {
        ajuste_multa += this.centsToReal(juros.valor) ?? 0;
      }

      const correcao = bill.valores_faturados.find((item) => {
        return item.descricao?.includes("Correção");
      });
      if (correcao) {
        ajuste_multa += this.centsToReal(correcao.valor) ?? 0;
      }

      return ajuste_multa;
    },

    setCreditosGerados(bill) {
      const creditosGerados = bill?.informacoes_tecnicas?.find(
        (item) => item.tipo_medicao === "Energia Injetada",
      );
      return creditosGerados ? creditosGerados.consumo : null;
    },

    setConsumo(bill) {
      const consumo = bill?.informacoes_tecnicas?.find(
        (item) => item.tipo_medicao === "Energia kWh",
      );
      return consumo ? consumo.consumo : null;
    },

    centsToReal(cents) {
      return (cents / 100).toFixed(2);
    },

    async validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        if (this.read_at > this.today) {
          this.snack(
            "A data da leitura deve ser igual ou anterior a hoje",
            "red",
            "top",
          );
          this.read_at = "";
          return;
        }
        if (this.read_at && this.read_at >= this.next_read_at) {
          this.snack(
            "A data da próxima leitura deve ser depois da data de leitura.",
            "red",
            "top",
          );
          this.read_at = "";
          this.next_read_at = "";
          return;
        }

        if (this.issued_at > this.today) {
          this.snack(
            "A data de emissão deve ser igual ou anterior a hoje.",
            "red",
            "top",
          );
          this.issued_at = "";
          return;
        }

        if (this.read_at > this.issued_at) {
          this.snack(
            "A data de emissão deve ser igual ou depois da data de leitura.",
            "red",
            "top",
          );
          this.read_at = "";
          this.issued_at = "";
          return;
        }

        const mes = this.competence.substring(0, 2);
        const ano = this.competence.substring(2, 6);
        const newCompetence = ano + "-" + mes;
        const power_plant_id =
          this.power_plant.power_plant_id || this.power_plant_id;
        const totals = {
          competence: newCompetence,
          power_plant_id: this.power_plant.power_plant_id,
          power_plant_power_monthly: this.power_plant_power_monthly,
          power_plant_amount: this.power_plant_amount * 1,
          power_plant_consumption_kW: this.power_plant_consumption_kW * 1,
          power_plant_custo_disp_kW: this.power_plant_custo_disp_kW * 1,
          number_of_customers: 0,
          last_balance: this.last_balance * 1,
          current_balance: this.current_balance * 1,
          dias_leitura: this.dias_leitura,
          valor_conta: this.valor_conta,
          cobraCustoDisp: this.cobraCustoDisp,
          retira_imposto: this.retira_imposto,
          start_at: this.start_at,
          auto_invoice_submission: this.auto_invoice_submission,
          auto_transaction: this.auto_transaction,
          retained_account: this.retained_account,
          total_payable: this.total_payable,
          adjustment_or_fine: this.adjustment_or_fine,
          read_at: this.read_at,
          issued_at: this.issued_at,
          next_read_at: this.next_read_at,
          split: this.split,
          estimated_kwh_value: parseFloat(this.estimated_kwh_value),
          estimated_kwh_comp_value: parseFloat(this.estimated_kwh_comp_value),
          estimated_kwh_amount_value: parseFloat(
            this.estimated_kwh_amount_value,
          ),
          estimated_kwh_amount_value_gd2: parseFloat(
            this.estimated_kwh_amount_value_gd2,
          ),
          utility_company: this.power_plant.utility_company,
        };

        if (this.newForm) {
          await createTotalBilling(
            this.power_plant.power_plant_id,
            newCompetence,
            totals,
          )
            .then(async () => {
              if (this.upload_file[0]?.name?.length > 0) {
                try {
                  const data = {
                    id: `${this.power_plant.power_plant_id}-${newCompetence}`,
                    data: this.upload_file,
                    agent_email: this.user?.email || "unknown",
                  };
                  await uploadEnergyBill(data);
                  await this.getDocumentsCompetence({
                    power_plant_id: this.power_plant_id,
                    newCompetence: this.newCompetence,
                  });
                  window.location.reload();
                } catch (error) {
                  console.error(error);
                  this.loading = false;
                  this.snack("Erro anexar conta de energia!", "red");
                  return;
                }
              }
              this.$emit("showSnack", "Competência adicionada!", "green");
              this.loading = false;
              this.close();
            })
            .catch((error) => {
              this.snack(error, "error", "top");
              this.loading = false;
            });
        } else {
          await updateInvoiceTotal(power_plant_id, newCompetence, totals)
            .then(() => {
              this.$emit("showSnack", "Competência alterada!", "green");
              this.loading = false;
              this.close();
              window.location.reload();
            })
            .catch((error) => {
              this.snack(
                "Erro ao alterar a competência! " + error,
                "error",
                "top",
              );
              this.loading = false;
            });
        }
      }
    },

    deleteSplit(index) {
      this.split.splice(index);
    },

    saveSplit(val) {
      if (this.$refs.addSplitform.validate()) {
        val.partner = this.partner.id;
        val.recipient_id = this.bankAccount.id;
        this.split.push(val);
        this.split_form = {
          charge_processing_fee: true,
          liable: true,
          partner: true,
          percentage: 0,
          recipient_id: null,
        };
        this.addSplit = false;
      }
    },

    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    bankText(item) {
      return `${
        item.bank_account && item.bank_account.legal_name
          ? item.bank_account.legal_name
          : ""
      }`;
    },

    competenceToMonth(value) {
      if (!value) return;
      const split = value.split("/");
      const month = split[0];
      switch (month) {
        case "01":
          return "Jan";
        case "02":
          return "Fev";
        case "03":
          return "Mar";
        case "04":
          return "Abr";
        case "05":
          return "Mai";
        case "06":
          return "Jun";
        case "07":
          return "Jul";
        case "08":
          return "Ago";
        case "09":
          return "Set";
        case "10":
          return "Out";
        case "11":
          return "Nov";
        case "12":
          return "Dez";
        default:
          return;
      }
    },

    getPvsyst() {
      if (this.power_plant) {
        const pvsyst = this.power_plant.pvsyst_expectation;
        if (pvsyst) return pvsyst;
      }
    },

    // Função que retorna a energia esperada para a planta
    async updatePowerPlantPowerMonthly() {
      if (this.power_plant) {
        const type = this.power_plant.type;
        const formatedCompetence = this.competence?.replace(
          /(\d{2})(\d{4})/,
          "$1/$2",
        );
        const comp_to_month = this.competenceToMonth(formatedCompetence);
        const pvsyst = this.getPvsyst();
        if (pvsyst) {
          for (let i = 0; i <= pvsyst.length; i++) {
            if (pvsyst[i].month === comp_to_month) {
              /*
                Caso a usina seja micro
                retorna o valor do mês atual
              */
              if (type === "micro") {
                this.power_plant_power_monthly =
                  Number(pvsyst[i].energy) * 1000;
                return this.power_plant_power_monthly;
              }
              /*
               Caso a usina seja mini
                é utilizado o valor do mês anterior
              */
              if (type === "mini") {
                this.power_plant_power_monthly =
                  Number(
                    pvsyst[i].month === "Jan"
                      ? pvsyst[11].energy
                      : pvsyst[i - 1].energy,
                  ) * 1000;
                return this.power_plant_power_monthly;
              }
            }
          }
        } else this.power_plant_power_monthly = this.power_plant.power_monthly;
        /*
         Caso a usina não tenha o 
          Pvsyst, retora o power_monthly cadastrado
        */
      }
    },

    removeEnergyBill() {
      this.upload_file = [
        {
          name: "",
          data: null,
        },
      ];
    },

    pickEnergyBill() {
      this.$refs.upload_file.click();
    },

    pickedEnergyBill(event) {
      const accountFile = event.target.files;
      this.upload_file = [
        {
          name: accountFile[0].name,
          data: accountFile[0],
        },
      ];
      this.detectFiles(accountFile);
      event.target.value = "";
    },

    async getEnergyFile(id) {
      if (id) {
        const report = await this.getEnergyBill({ id });
        this.upload_file_link = report ? report.url : null;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.align {
  max-width: fit-content !important;
}
</style>
